function Metchant () {
    return (
        <div>
            <h1>Merchant Page</h1>
        </div>
    )
}

export default Metchant